// Recipe cards (PDF) provided by World Farmers, keyed by crop id from crops.js.
// Files live in /public/recipes/. Image-based cards were converted to PDF.

export const RECIPES = {
  "amaranth": [
    {
      "title": "Amaranth and Mushroom (Callaloo)",
      "file": "/recipes/amaranth-and-mushroom.pdf"
    },
    {
      "title": "Braised Red Amaranth",
      "file": "/recipes/braised-red-amaranth.pdf"
    },
    {
      "title": "Amaranth Greens with Pork",
      "file": "/recipes/amaranth-greens-with-pork.pdf"
    }
  ],
  "asian-arugula": [
    {
      "title": "Arugula and Asian Pear Salad",
      "file": "/recipes/arugula-and-asian-pear-salad.pdf"
    }
  ],
  "asian-mustards": [
    {
      "title": "Wilted Mustard Greens",
      "file": "/recipes/wilted-mustard-greens.pdf"
    },
    {
      "title": "Sautéed Red Mustard Greens",
      "file": "/recipes/sauteed-red-mustard-greens.pdf"
    },
    {
      "title": "Chinese Pickled Mustard Greens",
      "file": "/recipes/chinese-pickled-mustard-greens.pdf"
    }
  ],
  "bitter-melon": [
    {
      "title": "Bitter Melon Yogurt Stew",
      "file": "/recipes/bitter-melon-yogurt-stew.pdf"
    },
    {
      "title": "Bitter Melon Chicken Soup",
      "file": "/recipes/bitter-melon-chicken-soup.pdf"
    }
  ],
  "broccoli": [
    {
      "title": "Garlic Lemon Broccolini",
      "file": "/recipes/garlic-lemon-broccolini.pdf"
    }
  ],
  "chinsaga": [
    {
      "title": "Chinsaga Leaves (Saga/Saget) in Onions & Tomatoes",
      "file": "/recipes/chinsaga-in-onions-and-tomatoes.pdf"
    }
  ],
  "chipili-n": [
    {
      "title": "Chipilín Soup",
      "file": "/recipes/chipilin-soup.pdf"
    }
  ],
  "chives": [
    {
      "title": "Flowering Garlic Chives with Ginger Butter",
      "file": "/recipes/garlic-chives-with-ginger-butter.pdf"
    }
  ],
  "cilantro": [
    {
      "title": "Chicken and Cilantro Bites",
      "file": "/recipes/chicken-and-cilantro-bites.pdf"
    }
  ],
  "cowpea-leaves-kunde": [
    {
      "title": "Sautéed Kunde Leaves with Tomatoes and Onions",
      "file": "/recipes/sauteed-kunde-leaves.pdf"
    }
  ],
  "cranberry-beans": [
    {
      "title": "Stewed Cranberry Beans",
      "file": "/recipes/stewed-cranberry-beans.pdf"
    }
  ],
  "daikon-radish": [
    {
      "title": "Sweet Pickled Daikon Radish",
      "file": "/recipes/sweet-pickled-daikon-radish.pdf"
    }
  ],
  "dill": [
    {
      "title": "Cucumber, Potato and Dill Salad",
      "file": "/recipes/cucumber-potato-and-dill-salad.pdf"
    }
  ],
  "eggplant": [
    {
      "title": "White Eggplant Steak",
      "file": "/recipes/white-eggplant-steak.pdf"
    }
  ],
  "fuzzy-melon-fuzzy-gourd": [
    {
      "title": "Sautéed Shredded Fuzzy Melon",
      "file": "/recipes/sauteed-shredded-fuzzy-melon.pdf"
    },
    {
      "title": "Fuzzy Melon and Glass Vermicelli Stir-Fry",
      "file": "/recipes/fuzzy-melon-glass-vermicelli-stir-fry.pdf"
    }
  ],
  "garlic-scapes": [
    {
      "title": "Garlic Scape Pesto",
      "file": "/recipes/garlic-scape-pesto.pdf"
    }
  ],
  "hot-asian-peppers": [
    {
      "title": "Hot Pepper Sauce",
      "file": "/recipes/hot-pepper-sauce.pdf"
    }
  ],
  "jilo": [
    {
      "title": "Jiló and Farm Fresh Vegetables",
      "file": "/recipes/jilo-and-farm-fresh-vegetables.pdf"
    },
    {
      "title": "Crispy Pan-Fried Jiló",
      "file": "/recipes/crispy-pan-fried-jilo.pdf"
    }
  ],
  "lalu": [
    {
      "title": "Haitian Lalu Stew",
      "file": "/recipes/haitian-lalu-stew.pdf"
    }
  ],
  "lemongrass": [
    {
      "title": "Vietnamese Lemongrass Chicken",
      "file": "/recipes/vietnamese-lemongrass-chicken.pdf"
    },
    {
      "title": "Fresh Lemongrass Tea",
      "file": "/recipes/fresh-lemongrass-tea.pdf"
    }
  ],
  "malabar-spinach": [
    {
      "title": "Malabar Spinach Stir-Fry",
      "file": "/recipes/malabar-spinach-stir-fry.pdf"
    },
    {
      "title": "Malabar Spinach and Potato Stir-Fry",
      "file": "/recipes/malabar-spinach-and-potato-stir-fry.pdf"
    }
  ],
  "managu-night-shade": [
    {
      "title": "Creamy Butterless Managu",
      "file": "/recipes/creamy-butterless-managu.pdf"
    }
  ],
  "maxixe": [
    {
      "title": "Maxixe Salad",
      "file": "/recipes/maxixe-salad.pdf"
    }
  ],
  "pea-tendrils": [
    {
      "title": "Flash-Cooked Pea Shoots with Garlic",
      "file": "/recipes/flash-cooked-pea-shoots-with-garlic.pdf"
    },
    {
      "title": "Fresh Pea Tendril Salad",
      "file": "/recipes/fresh-pea-tendril-salad.pdf"
    }
  ],
  "pumpkins-blossoms-leaves-vines": [
    {
      "title": "Crispy Pumpkin Blossoms",
      "file": "/recipes/crispy-pumpkin-blossoms.pdf"
    },
    {
      "title": "Muboora (Pumpkin Leaves)",
      "file": "/recipes/muboora-pumpkin-leaves.pdf"
    },
    {
      "title": "Pumpkin Leaf Braise",
      "file": "/recipes/pumpkin-leaf-braise.pdf"
    },
    {
      "title": "Pumpkin Leaf Fritters",
      "file": "/recipes/pumpkin-leaf-fritters.pdf"
    },
    {
      "title": "Pumpkin Vine",
      "file": "/recipes/pumpkin-vine.pdf"
    }
  ],
  "purslane": [
    {
      "title": "Purslane and Parsley Salad",
      "file": "/recipes/purslane-and-parsley-salad.pdf"
    },
    {
      "title": "Fresh Purslane Salad",
      "file": "/recipes/fresh-purslane-salad.pdf"
    }
  ],
  "sorrel": [
    {
      "title": "French Style Sorrel Soup",
      "file": "/recipes/french-style-sorrel-soup.pdf"
    }
  ],
  "sweet-potato-leaves": [
    {
      "title": "Easy Garlic Sautéed Sweet Potato Leaves",
      "file": "/recipes/garlic-sauteed-sweet-potato-leaves.pdf"
    }
  ],
  "taioba": [
    {
      "title": "Taioba Sauté",
      "file": "/recipes/taioba-saute.pdf"
    }
  ],
  "water-spinach": [
    {
      "title": "Stir-Fry Water Spinach",
      "file": "/recipes/stir-fry-water-spinach.pdf"
    }
  ],
  "yu-choi": [
    {
      "title": "Shrimp with Yu Choi Soup",
      "file": "/recipes/shrimp-with-yu-choi-soup.pdf"
    }
  ]
};

export const RECIPE_COUNT = Object.values(RECIPES).reduce((n, list) => n + list.length, 0);
export const RECIPE_CROP_COUNT = Object.keys(RECIPES).length;
export const recipesFor = (cropId) => RECIPES[cropId] || [];
export const hasRecipes = (cropId) => (RECIPES[cropId] || []).length > 0;
// First-page preview rendered from each PDF; lives in /public/recipes/thumbs/.
export const recipeThumb = (recipe) => recipe.file.replace("/recipes/", "/recipes/thumbs/").replace(/\.pdf$/, ".jpg");
export const recipeSlug = (recipe) => recipe.file.split("/").pop().replace(/\.pdf$/, "");
